import styled from 'styled-components'
import { Spacings, Text } from '@styles'

export const PageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_4B};
	// padding: ${Spacings.SPACING_1B};
	height: 100%;
	box-sizing: border-box;
	background: ${({ theme }) => theme.colors.surface.sunken};
	font-family: ${({ theme }) => theme.fontFamily?.inter || "'Inter', sans-serif"};

	* {
		font-family: inherit;
	}
`

export const RolesWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: ${Spacings.SPACING_1B};
`

export const StackCell = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_1};

	& > b {
		font-weight: ${Text.BOLD_500};
		color: ${({ theme }) => theme.colors.text.primary};
	}
	& > small {
		color: ${({ theme }) => theme.colors.text.secondary};
	}
`

export const OrgName = styled.b`
	font-size: ${Text.MEDIUM};
`

/* ── Filters / actions bar ─────────────────────────────────────────────── */
export const FilterBar = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: ${Spacings.SPACING_4B};
	padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
	background: ${({ theme }) => theme.colors.surface.card};
	border: 1px solid ${({ theme }) => theme.colors.border.default};
	border-radius: ${({ theme }) => theme.radius.lg};
	flex-wrap: wrap;
`

export const FilterControls = styled.div`
	display: flex;
	align-items: flex-end;
	gap: ${Spacings.SPACING_4B};
	flex-wrap: wrap;
`

export const FilterField = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_1B};
	min-width: 14rem;
`

export const FilterActions = styled.div`
	display: flex;
	align-items: center;
	gap: ${Spacings.SPACING_2B};
`

/* ── Drawer form layout ────────────────────────────────────────────────── */
export const InputsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_4B};
`

export const SearchRow = styled.div`
	display: flex;
	align-items: flex-end;

	gap: ${Spacings.SPACING_2B};

	& > div:first-child {
		flex: 1;
	}
`

export const PhoneRow = styled.div`
	display: grid;
	grid-template-columns: minmax(6rem, max-content) 1fr;
	gap: ${Spacings.SPACING_2B};
	align-items: flex-end;
`
